import { removeAuthToken, setAuthToken } from '../../auth';

import type { Settings } from '@/types/settings';

/**
 * Initialises site state from settings context data. Handles auth side
 * effects (cookies, sessionStorage). Called from TopBar on mount.
 */
export function setupSite(data: Settings | null | undefined) {
  if (!data) {
    return;
  }

  // The API may return numeric status codes at runtime even though
  // the Settings type declares status as string
  if ((data.status as string | number) === 500) {
    removeAuthToken();
    return;
  }

  if (data.status !== 'success') {
    return;
  }

  if (data?.subscriptionData?.isActive) {
    sessionStorage.setItem('is_premium_track_list', '1');
  } else {
    sessionStorage.setItem('is_premium_track_list', '0');
  }

  if (data.user.is_authenticated && data?.user?.email) {
    localStorage.setItem('quick_login', data.user.email);
  }

  if (data.user.is_authenticated) {
    // setup_frontend authenticates off the PHP session and returns the real
    // token here, so this re-creates a missing auth_token cookie. The JWT
    // refresh is gated on that cookie; drop this and v2 calls (checkout
    // preview, downloads) fail for any session that lost it (DEV-6744).
    if (data.user.auth_token) {
      setAuthToken(data.user.auth_token);
    }
  } else {
    sessionStorage.removeItem('user_is_authenticated');
  }

  return data;
}
